export default {
    getCookie(e) {
        let r, i = new RegExp("(^| )" + e + "=([^;]*)(;|$)");
        return (r = document.cookie.match(i)) ? unescape(r[2]) : null
    },
    // 判断是否为手机端
    isPhone: function(){
        var isPhone;
        if(navigator.userAgent.match(/(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowerNG|WebOS|Symbian|Windows Phone)/i)){
        isPhone = true;
        }else {
        isPhone = false;
        }
        return isPhone;
    },
    // 判断是否是iOS
    isiOS: function () {
        let u = navigator.userAgent
        let ipad = u.indexOf('iPad') > -1 || u.indexOf('Mac OS X') > -1
        let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || ipad
        if (ios) {
            return ios
        } else {
            return false
        }
    },
    getQueryString: function (name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
        let r = window.location.href.split('?')[1].match(reg)
        if(r != null) {
          return decodeURIComponent(r[2])
          }
        return ''
    },
}